<template>
    <div class="pb-3">
        <div class="panel-tag mt-2">
            {{__t("WOLT_LOCATION_PARAMS")}}
        </div>

        <div class="choose_type pb-4">
            <yes_no
                key="WOLT_TYPE"
                v-model="location.general_fields.type"
                :radio_options="radio_options"
                title="WOLT_TYPE">

            </yes_no>
        </div>


        <div class="form-group mt-2" v-for="general_field in general_fields" :key="general_field.key">
            <label class="form-label">
                {{ get_wolt_param_name(general_field.title) }}
            </label>

            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal fa-typewriter fs-xl"></i>
                    </span>
                </div>

                <input
                    :id="general_field.key"
                    type="text"
                    class="form-control"
                    v-model="location.general_fields[general_field.key]"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Yes_no from "../../../sys/radio/yes_no.vue";

export default {
    name: "wolt_drive_params",
    components: {Yes_no},

    data() {
        return {
            restaurants : [],
        }
    },
    props : {
        location : {
            type : Object
        }
    },

    methods : {
        get_wolt_param_name(type)
        {
            return type;
        },
    },

    computed: {

        radio_options() {
            return [
                {text: 'Venueful',  value: '0'},
                {text: 'Venueless', value: '1'},
            ];
        },

        cur_params_type () {
            try {
                return parseInt(this.location.general_fields.type);
            }
            catch (e) {

            }

            return 0;
        },


        is_type_ven() {
            return  parseInt(this.cur_params_type) == 1;
        },


        general_fields() {
            if(this.location.hasOwnProperty("general_fields")) {
                let res = [];
                let excludedKeys = ['id', 'created_at', 'type'];

                if(this.is_type_ven) {
                    excludedKeys = ['id','type','venue_id','sms_received','sms_picked_up'];
                }


                for (const [key, value] of Object.entries(this.location.general_fields)) {
                    if (!excludedKeys.includes(key)) {
                        res.push({
                            key: key,
                            value: value,
                            title: this.__t(key.toUpperCase())
                        });
                    }
                }
                return res;
            }
            return [];
        },
    },
}
</script>



<style scoped>

</style>
